module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/27fc07ebfd45adc967ea6c0662e345f2.svg";


//////////////////
// WEBPACK FOOTER
// ./components/certificates/components/rank-dropdown/assets/dropdownUp.svg
// module id = j6ze
// module chunks = 1